export default "__VITE_ASSET__788001a6__"